import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormHeaderStateService {
  // The save button is enabled by default. Ensures that the save button is not disabled unless explicitly set to false by the service
  private saveButtonEnabled = new BehaviorSubject<boolean>(true);
  saveButtonEnabled$ = this.saveButtonEnabled.asObservable();

  enableSaveButton() {
    this.saveButtonEnabled.next(true);
  }

  disableSaveButton() {
    this.saveButtonEnabled.next(false);
  }
}
